import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Grid } from '@material-ui/core';
import { isEmpty } from 'lodash';
import MainButton from '../../MUI/MainButton';
import useDeviceResize from '../../../hooks/useDeviceResize';
import { PAYMENT_FREQUENCIES } from '../../../constants/paymentFrequency';

import useStyles from './makeStyles';

const PaymentFrequencyTypes = ({
  prices,
  setPaymentFrequency,
  paymentFrequency,
  paymentFrequencies,
}) => {
  const { t } = useTranslation();
  const isDeviceMobileSize = useDeviceResize('sm');
  const classes = useStyles();

  const firstSubObjectValues = prices && Object.values(prices)[0];

  const existingPaymentFrequencies = firstSubObjectValues
    ? Object.keys(firstSubObjectValues)
      .filter((frequency) => firstSubObjectValues[frequency].sum > 0)
    : [];

  const filteredFrequencies = existingPaymentFrequencies.length
    ? Object.keys(PAYMENT_FREQUENCIES)
      .filter((frequency) => existingPaymentFrequencies.includes(frequency))
    : Object.keys(PAYMENT_FREQUENCIES);

  const getMdSize = (length) => {
    switch (length) {
      case 2:
        return 6;
      case 3:
        return 4;
      case 4:
      default:
        return 3;
    }
  };

  const mdSize = getMdSize(filteredFrequencies.length);

  return (
    filteredFrequencies.map((frequency) => (
      <Grid item sm={6} xs={6} md={mdSize} key={frequency}>
        <MainButton
          color="primary"
          className={classNames(classes.mainButton, {
            [classes.active]: paymentFrequency.value === frequency,
            [classes.disabled]: isEmpty(paymentFrequencies) || isEmpty(prices),
          })}
          variant={paymentFrequency.value === frequency ? 'contained' : 'outlined'}
          style={{
            fontSize: isDeviceMobileSize ? 12 : 14,
            width: '100%',
          }}
          onClick={() => setPaymentFrequency(PAYMENT_FREQUENCIES[frequency])}
        >
          {t(PAYMENT_FREQUENCIES[frequency].translationPath)}
        </MainButton>
      </Grid>
    ))
  );
};

PaymentFrequencyTypes.propTypes = {
  prices: PropTypes.shape({}),
  setPaymentFrequency: PropTypes.func.isRequired,
  paymentFrequency: PropTypes.shape({}).isRequired,
};

PaymentFrequencyTypes.defaultProps = {
  prices: {},
};

export default PaymentFrequencyTypes;
